/**
 * @generated SignedSource<<a60f6ff59870162c9101ed2ff9e06294>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RedemptionTypeKey = "CHARITY" | "GIFT_CARD" | "MOBILE" | "PAYPAL" | "VENMO";
export type RedemptionTypeStatus = "AVAILABLE" | "OFFLINE" | "REQUIRES_VERIFICATION";
export type RewardOptionsQuery$variables = {
  redemptionType: RedemptionTypeKey;
  redirectUrl: string;
};
export type RewardOptionsQuery$data = {
  readonly redemptionOptions: {
    readonly " $fragmentSpreads": FragmentRefs<"RedemptionOptions_redemptionOptionsRef">;
  } | null;
  readonly redemptionTypes: {
    readonly types: ReadonlyArray<{
      readonly linkNewAccountUrl: string | null;
      readonly name: RedemptionTypeKey;
      readonly status: RedemptionTypeStatus;
    }>;
    readonly " $fragmentSpreads": FragmentRefs<"RedemptionFacets_redemptionTypes">;
  } | null;
  readonly walletBalance: {
    readonly " $fragmentSpreads": FragmentRefs<"CurrentEarningsCard_currentEarnings">;
  } | null;
};
export type RewardOptionsQuery = {
  response: RewardOptionsQuery$data;
  variables: RewardOptionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "redemptionType"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "redirectUrl"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": [
    {
      "fields": [
        {
          "kind": "Variable",
          "name": "redirectUrl",
          "variableName": "redirectUrl"
        }
      ],
      "kind": "ObjectValue",
      "name": "input"
    }
  ],
  "kind": "ScalarField",
  "name": "linkNewAccountUrl",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v4 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "redemptionType",
        "variableName": "redemptionType"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v5 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "subUnitAmount",
    "storageKey": null
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RewardOptionsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "WalletBalance",
        "kind": "LinkedField",
        "name": "walletBalance",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CurrentEarningsCard_currentEarnings"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "RedemptionTypes",
        "kind": "LinkedField",
        "name": "redemptionTypes",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "RedemptionFacets_redemptionTypes"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RedemptionType",
            "kind": "LinkedField",
            "name": "types",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "RedemptionOptionConnection",
        "kind": "LinkedField",
        "name": "redemptionOptions",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "RedemptionOptions_redemptionOptionsRef"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RewardOptionsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "WalletBalance",
        "kind": "LinkedField",
        "name": "walletBalance",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CurrencyAmount",
            "kind": "LinkedField",
            "name": "amount",
            "plural": false,
            "selections": (v5/*: any*/),
            "storageKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "RedemptionTypes",
        "kind": "LinkedField",
        "name": "redemptionTypes",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RedemptionType",
            "kind": "LinkedField",
            "name": "types",
            "plural": true,
            "selections": [
              (v6/*: any*/),
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "RedemptionOptionConnection",
        "kind": "LinkedField",
        "name": "redemptionOptions",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RedemptionOptionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RedemptionOptionData",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AmountDenomination",
                    "kind": "LinkedField",
                    "name": "amountDenominations",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CurrencyAmount",
                        "kind": "LinkedField",
                        "name": "panelistCost",
                        "plural": false,
                        "selections": (v5/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "imageUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "key",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8c30bb12c9f71755153ffbc8106eed94",
    "id": null,
    "metadata": {},
    "name": "RewardOptionsQuery",
    "operationKind": "query",
    "text": "query RewardOptionsQuery(\n  $redemptionType: RedemptionTypeKey!\n  $redirectUrl: String!\n) {\n  walletBalance {\n    ...CurrentEarningsCard_currentEarnings\n    id\n  }\n  redemptionTypes {\n    ...RedemptionFacets_redemptionTypes\n    types {\n      name\n      linkNewAccountUrl(input: {redirectUrl: $redirectUrl})\n      status\n      id\n    }\n    id\n  }\n  redemptionOptions(input: {redemptionType: $redemptionType}) {\n    ...RedemptionOptions_redemptionOptionsRef\n  }\n}\n\nfragment CurrentEarningsCard_currentEarnings on WalletBalance {\n  amount {\n    subUnitAmount\n  }\n  id\n}\n\nfragment RedemptionFacets_redemptionTypes on RedemptionTypes {\n  types {\n    id\n    name\n  }\n  id\n}\n\nfragment RedemptionOptions_redemptionOptionsRef on RedemptionOptionConnection {\n  edges {\n    node {\n      id\n      name\n      amountDenominations {\n        panelistCost {\n          subUnitAmount\n        }\n      }\n      ...useRedemptionOptionItemQuery_optionRef\n    }\n  }\n}\n\nfragment useRedemptionOptionItemQuery_optionRef on RedemptionOptionData {\n  imageUrl\n  key\n  name\n}\n"
  }
};
})();

(node as any).hash = "698021d19504fc3e173532365cb68659";

export default node;
